import Vue from 'vue'
import VueStorage from 'vue-ls'
import config from '@/config/defaultSettings'
import cloneDeep from 'lodash/cloneDeep'
import { message, notification } from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less'
import MultiTab from '@/components/MultiTab'
import IconFont from '@/components/IconFont'

Vue.use(IconFont)

message.config({
	maxCount: 6,
})
notification.config({
	duration: 4,
})

// base library
import '@/core/lazy_lib/components_use'
// import Viser from 'viser-vue'

// ext library

// @ts-ignore
// import VueClipboard from 'vue-clipboard2'
import PermissionHelper from '@/utils/helper/permission'
import AudioPlayer from '@/components/AudioPlayer'

// import VueLazyload from 'vue-lazyload'
//
// Vue.use(VueLazyload, {
// 	filter: {
// 		scale(listener: any) {
// 			listener.src += '?imageMogr2/thumbnail/192x'
// 		},
// 	},
// })

// VueClipboard.config.autoSetContainer = true

// Vue.use(Viser)
Vue.use(MultiTab)

Vue.use(VueStorage, config.lsOptions)
Vue.use(cloneDeep(VueStorage), config.ssOptions)
// Vue.use(VueClipboard)
Vue.use(PermissionHelper)
Vue.use(AudioPlayer)
